import {
  GET_INCIDENT_INFO_INIT,
  GET_INCIDENT_INFO_SUCCESS,
  GET_INCIDENT_INFO_FAILURE,
} from '../actions/types';
import initialState from './initialState';

/**
 * Reducer for popup of the marker
 * -incident data, slider images data
 */
export default function (state = initialState.popUp, action) {
  switch (action.type) {
    // Cases to load the incident information
    case GET_INCIDENT_INFO_INIT:
      return {
        ...state,
        errorPopUp: null,
      };
    case GET_INCIDENT_INFO_SUCCESS:
      return {
        ...state,
        incidentData: action.payload[0],
        sliderData: action.payload[1],
        errorPopUp: null,
      };
    case GET_INCIDENT_INFO_FAILURE:
      return {
        ...state,
        errorPopUp: action.payload,
      };
    default:
      return state;
  }
}
